// extracted by css-extract-rspack-plugin
module.exports =  {"cardContainer":"TaxExtensionProgressionActions__cardContainer___t77qY"};